import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { InvoiceReportAsPaidFormViewProps } from "models/propTypes/invoicePropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { InvoiceFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { DateInputProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { DateInput, useWintForm, VerticalFormField, WintForm } from "components/common/wintForms";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const InvoiceReportAsPaidForm: ForwardRefRenderFunction<FormHandles, InvoiceReportAsPaidFormViewProps> = (
  props,
  ref
) => {
  const { wintFormProps, connect } = useWintForm<InvoiceFormTypes.ReportAsPaid>({
    formRef: ref,
    ...props,
    validateOnBlur: true,
  });

  return (
    <WintForm {...wintFormProps}>
      <Grid sm={4}>
        <VerticalFormField<DateInputProps>
          Component={DateInput}
          {...connect("paymentDate")}
          controlLabel={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.WhenDidCustomerPay)}
          label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PaymentDate)}
          maxDate={new Date()}
          showMainLabel
        />
      </Grid>
    </WintForm>
  );
};

export default forwardRef(InvoiceReportAsPaidForm);
